import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactGA from "react-ga";
import { values } from "lodash";
import Checkbox from "../Checkbox";
import styles from "../../../styles/FilterSection.module.scss";
import { getTagTypeDisplayName, getTagDisplayName } from "../../../utils";
import { TAG_TYPE } from "../../../constants";
import { searchCpls, searchPlaylistPackTypes } from "../../../api";
import TagSearch from "./TagSearch";

const parseSearchList = (data, type) => {
  const items = Array.isArray(data) ? data : data?.data || [];
  return items.slice(0, 15).map((item) => {
    const name = item.name || item.contentName || item.displayName || item.title || item.id;
    return {
      id: item.id,
      name,
      displayName: name,
      tag: item.code || item.id,
      type,
    };
  });
};

class SearchFilterSection extends Component {
  static propTypes = {
    tagType: PropTypes.oneOf(values(TAG_TYPE)).isRequired,
    selected: PropTypes.array,
    onFilterChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selected: [],
  };

  onFilterChange = (filter) => {
    this.props.onFilterChange(filter);
    if (filter?.type)
      ReactGA.event({ category: "filter", action: "right-panel-search", label: filter.type });
  };

  render() {
    const { tagType, selected, onFilterChange } = this.props;
    const placeholder = `Search ${getTagTypeDisplayName(tagType)}`;
    const searchConfig =
      tagType === TAG_TYPE.CONTENT
        ? {
            fetchAction: searchCpls,
            parseResults: (data) => parseSearchList(data, TAG_TYPE.CONTENT),
          }
        : tagType === TAG_TYPE.PLAYLIST_PACK
        ? {
            fetchAction: searchPlaylistPackTypes,
            parseResults: (data) => parseSearchList(data, TAG_TYPE.PLAYLIST_PACK),
          }
        : {};
    return (
      <div>
        <TagSearch
          showSubText
          tagTypes={tagType}
          placeholder={placeholder}
          onSelect={onFilterChange}
          {...searchConfig}
        />
        {selected.length > 0 && (
          <div className={styles.selectedList}>
            {selected.map((tag) => (
              <Checkbox
                key={tag.id}
                checked
                label={getTagDisplayName(tag)}
                onChange={() => this.onFilterChange(tag)}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default SearchFilterSection;
